import React, { useState, useEffect } from 'react';
import { mascaraTelefone } from 'utils/telefone';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import dayjs from 'dayjs';

import http from 'services/http';
import InputUsuario from 'components/Usuarios/InputUsuario';
import { alerta } from "../../../../components/Alert";
import { toast } from "react-toastify";
import { Redirect } from "react-router-dom";
import SecaoPermissoes, { PERMISSOES_SUBADMIN } from './SecaoPermissoes';
import { moedaInput, moedaDisplay, parseMoeda } from 'utils/moedaInput';
import { tipoOperador } from 'utils/tipoOperador';
import VinculoGerenteLoteria from 'components/VinculoGerenteLoteria';

const MySwal = withReactContent(Swal);

export default function Editar(props) {
    const [abaAtiva, setAbaAtiva] = useState('dados');
    const [login, setLogin] = useState('');
    const [senha, setSenha] = useState('');
    const [listaGerente, setListaGerente] = useState([]);
    const [tipoGerente, setTipoGerente] = useState();
    const [gerente, setGerente] = useState('');
    const [comissaoGerente, setComissaoGerente] = useState(0);
    const [comissaoLucro, setComissaoLucro] = useState(0);
    const [porcentagemSocio, setPorcentagemSocio] = useState(0);
    const [saldo, setSaldo] = useState('');
    const [comissaoMilhar, setComissaoMilhar] = useState(0);
    const [comissaoCentena, setComissaoCentena] = useState(0);
    const [comissaoDezena, setComissaoDezena] = useState(0);
    const [comissaoGrupo, setComissaoGrupo] = useState(0);
    const [cotaEscolhida, setCotaEscolhida] = useState(1);
    const [endereco, setEndereco] = useState('');
    const [telefone, setTelefone] = useState('');
    const [descricao, setDescricao] = useState('');
    const [milharBrindeUsuario, setMilharBrindeUsuario] = useState(true);
    const [nivel, setNivel] = useState('');
    const [modalidades, setModalidades] = useState([]);
    const [dataCriacao, setDataCriacao] = useState('');
    const [permissaoCriarOperador, setPermissaoCriarOperador] = useState(false);
    const [permissaoAdicionarSaldo, setPermissaoAdicionarSaldo] = useState(false);
    const [permissaoExibirLogo, setPermissaoExibirLogo] = useState(false);
    const [nivelLogado, setNivelLogado] = useState('');
    const [cotacaoSelecionada, setCotacaoSelecionada] = useState(null);

    // Função para extrair valores da cotação
    const extrairValoresCotacao = (nomeCotacao) => {
        if (!nomeCotacao) return { M: 0, C: 0, D: 0, G: 0 };

        const regex = /M:\s*(\d+)\s*\/\s*C:\s*(\d+)\s*\/\s*D:\s*(\d+)\s*\/\s*G:\s*(\d+)/;
        const match = nomeCotacao.match(regex);

        if (match) {
            return {
                M: parseInt(match[1]),
                C: parseInt(match[2]),
                D: parseInt(match[3]),
                G: parseInt(match[4])
            };
        }
        return { M: 0, C: 0, D: 0, G: 0 };
    };

    // Função para calcular indicador de Milhar
    const calcularIndicadorMilhar = (cotacao, comissao) => {
        const M = cotacao + (comissao * 100);
        if (M > 9999) return { cor: '#dc3545', status: 'ALTA', simbolo: '●' };
        if (M >= 8999 && M <= 9999) return { cor: '#ffc107', status: 'MÉDIA', simbolo: '●' };
        return { cor: '#28a745', status: 'BAIXA', simbolo: '●' };
    };

    // Função para calcular indicador de Centena
    const calcularIndicadorCentena = (cotacao, comissao) => {
        const C = cotacao + (comissao * 10);
        if (C > 999) return { cor: '#dc3545', status: 'ALTA', simbolo: '●' };
        if (C >= 899 && C <= 999) return { cor: '#ffc107', status: 'MÉDIA', simbolo: '●' };
        return { cor: '#28a745', status: 'BAIXA', simbolo: '●' };
    };

    // Função para calcular indicador de Dezena
    const calcularIndicadorDezena = (cotacao, comissao) => {
        const D = cotacao + comissao;
        if (D > 99) return { cor: '#dc3545', status: 'ALTA', simbolo: '●' };
        if (D >= 89 && D <= 99) return { cor: '#ffc107', status: 'MÉDIA', simbolo: '●' };
        return { cor: '#28a745', status: 'BAIXA', simbolo: '●' };
    };

    // Função para calcular indicador de Grupo
    const calcularIndicadorGrupo = (cotacao, comissao) => {
        const G = 25.00 - cotacao - (comissao * 0.25);
        if (G <= 0) return { cor: '#dc3545', status: 'ALTA', simbolo: '●' };
        if (G > 0 && G < 2.50) return { cor: '#ffc107', status: 'MÉDIA', simbolo: '●' };
        return { cor: '#28a745', status: 'BAIXA', simbolo: '●' };
    };

    // Função para obter indicador geral
    const obterIndicadorGeral = () => {
        if (!cotacaoSelecionada) return { cor: '#6c757d', status: 'SEM COTAÇÃO' };

        const valores = extrairValoresCotacao(cotacaoSelecionada.nome);
        const indMilhar = calcularIndicadorMilhar(valores.M, parseFloat(comissaoMilhar) || 0);
        const indCentena = calcularIndicadorCentena(valores.C, parseFloat(comissaoCentena) || 0);
        const indDezena = calcularIndicadorDezena(valores.D, parseFloat(comissaoDezena) || 0);
        const indGrupo = calcularIndicadorGrupo(valores.G, parseFloat(comissaoGrupo) || 0);

        if ([indMilhar, indCentena, indDezena, indGrupo].some(ind => ind.status === 'ALTA')) {
            return { cor: '#dc3545', status: 'COMISSÃO ALTA' };
        }

        if ([indMilhar, indCentena, indDezena, indGrupo].some(ind => ind.status === 'MÉDIA')) {
            return { cor: '#ffc107', status: 'COMISSÃO MÉDIA' };
        }

        return { cor: '#28a745', status: 'COMISSÃO BAIXA' };
    };

    useEffect(() => {
        const requestUsuarios = async () => {
            try {
                const { id } = props.match.params;

                const response = await http.get('/usuarios/' + id);

                const { data: usuario } = response.data;

                setLogin(usuario.login);
                setNivel(usuario.nivel);

                setSaldo(moedaDisplay(usuario.saldo));
                setComissaoMilhar(usuario.comissao_milhar ?? usuario.comissao ?? 0);
                setComissaoCentena(usuario.comissao_centena ?? usuario.comissao ?? 0);
                setComissaoDezena(usuario.comissao_dezena ?? 0);
                setComissaoGrupo(usuario.comissao_grupo ?? 0);
                setComissaoGerente(usuario.comissao_gerente || '0');
                setComissaoLucro(usuario.comissao_lucro || '0');
                setPorcentagemSocio(usuario.porcentagem_socio || '0');
                setTipoGerente(usuario.tipo_usuario || 'gerente');
                setCotaEscolhida(usuario.cotas);

                setDescricao(usuario.observacao);
                setMilharBrindeUsuario(Boolean(usuario.milhar_brinde_usuario));
                setEndereco(usuario.endereco);
                setTelefone(mascaraTelefone(usuario.telefone));

                if (usuario.permissoes) {
                    setPermissaoAdicionarSaldo(
                        usuario.permissoes.adicionar_saldo || false,
                    );

                    setPermissaoCriarOperador(usuario.permissoes.criar_operador || false);

                    setPermissaoExibirLogo(usuario.permissoes.exibir_logo || true);
                }

                const data = dayjs(usuario.created_at).format('DD/MM/YYYY HH:mm');

                setDataCriacao(data);
                await setNivelLogado(localStorage.getItem('nivel'));

                if (usuario.nivel === 'operador') {
                    setGerente(usuario.gerente_id);

                    const resModalidades = await http.get('bancas/titulo-cotacoes');
                    setModalidades(resModalidades.data.data);

                    // Define a cotação selecionada
                    const cotacaoAtual = resModalidades.data.data.find(m => m.id === usuario.cotas);
                    if (cotacaoAtual) {
                        setCotacaoSelecionada(cotacaoAtual);
                    }

                    const response = await http.get('/usuarios', {
                        params: {
                            nivel: 'gerente',
                        },
                    });
                    const { data: usuarios } = response.data;
                    setListaGerente(usuarios);
                }
            } catch (e) {

            }
        };

        requestUsuarios();
    }, [props.match.params]);

    // Atualizar cotação selecionada quando mudar
    useEffect(() => {
        const cotacao = modalidades.find(m => m.id === parseInt(cotaEscolhida));
        if (cotacao) {
            setCotacaoSelecionada(cotacao);
        }
    }, [cotaEscolhida, modalidades]);

    const enviarModificacao = async () => {
        try {
            const { id } = props.match.params;

            if ((senha.length < 6 || senha.length > 18) && senha.length !== 0) {
                toast.error('A senha deve ter entre 6 e 18 caracteres');
                return;
            }

            const passwordObj = senha.length ? { password: senha } : {};

            const { data } = await http.put('/usuarios/' + id, {
                login,
                nivel,
                gerente_id: gerente,
                comissao_milhar: comissaoMilhar || 0,
                comissao_centena: comissaoCentena || 0,
                comissao_dezena: comissaoDezena || 0,
                comissao_grupo: comissaoGrupo || 0,
                saldo: parseMoeda(saldo),
                tipo_usuario: nivel === 'operador' ? undefined : tipoGerente,
                comissao_gerente: comissaoGerente || 0,
                comissao_lucro: comissaoLucro || 0,
                porcentagem_socio: porcentagemSocio || 0,
                cotas: cotaEscolhida,
                milhar_brinde_usuario: milharBrindeUsuario ? 1 : 0,
                exibir_logo: permissaoExibirLogo,
                endereco,
                telefone,
                observacao: descricao,
                permissao_criar_operador: permissaoCriarOperador,
                permissao_adicionar_saldo: permissaoAdicionarSaldo,
                ...passwordObj,
            });

            alerta(data)

            if (nivel === 'operador') {
                props.history.push(tipoOperador(tipoGerente).rotaLista);
            } else if (nivel === 'subadmin') {
                props.history.push('/subadmin')
            } else {
                props.history.push('/rota');
            }

        } catch (e) {
            alerta(e.response.data);
        }
    };

    const perguntarParaApagar = async () => {
        const { id } = props.match.params;

        Swal.fire({
            title: 'Deseja apagar o gerente?',
            text: 'Certifique-se de que não existem cambistas ligados ao gerente antes de apagar!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            reverseButtons: true,
            confirmButtonText: 'Sim, apagar!',
            cancelButtonText: 'Não, cancelar',
        }).then((result) => {
            if (result.value) {
                apagarRota(id);
            }
        });
    };

    const apagarRota = async (id) => {
        try {
            const res = await http.delete(`/usuarios/${id}`);

            alerta(res.data);

            props.history.push('/rota');
        } catch (e) {
            alerta(e.response.data)
        }
    };

    const handleComissaoChange = (valor, setter, max = 99) => {
        const valorLimitado = valor.slice(0, 2);
        const numero = parseInt(valorLimitado) || 0;
        if (numero <= max) {
            setter(valorLimitado);
        }
    };

    return (
        <div className='bordered'>
            <div>
                <div className='titulo-principal'>
                    {nivel === 'operador' ? (<span>{tipoOperador(tipoGerente).tituloEditar}</span>) : (<span>Atualizar Usuário</span>)}
                </div>

                {nivel === 'gerente' && (
                    <div style={{ display: 'flex', gap: 4, padding: '8px 10px 0', borderBottom: '1px solid #ddd' }}>
                        <button
                            type="button"
                            className={`btn btn-sm ${abaAtiva === 'dados' ? 'btn-primary' : 'btn-light'}`}
                            onClick={() => setAbaAtiva('dados')}
                        >
                            Dados
                        </button>
                        <button
                            type="button"
                            className={`btn btn-sm ${abaAtiva === 'extracoes' ? 'btn-primary' : 'btn-light'}`}
                            onClick={() => setAbaAtiva('extracoes')}
                        >
                            Extrações
                        </button>
                    </div>
                )}

                {nivel === 'gerente' && abaAtiva === 'extracoes' && (
                    <VinculoGerenteLoteria tipo="gerente" id={parseInt(props.match.params.id)} />
                )}

                {(nivel !== 'gerente' || abaAtiva === 'dados') && (<>
                    <div className='btn-group caixa-inputs p-b'>
                        <div className='input-criacao-usuario margin-vertical-30'>
                            <label
                                className='titulo-input-criacao'
                                style={{ marginBottom: 10 }}
                            >
                                Criado em:
                            </label>
                            <input
                                disabled
                                className='form-control input-dados-criar'
                                value={dataCriacao}
                            />
                        </div>

                        {(nivel === 'operador' && nivelLogado !== 'gerente') && (
                            <div className='input-criacao-usuario margin-vertical-30'>
                                <label className='titulo-input-criacao'>Gerente:</label>
                                <select
                                    required
                                    className='form-control input-dados-criar'
                                    id='inputGerente'
                                    onChange={(e) => setGerente(e.target.value)}
                                    value={gerente}
                                >
                                    {listaGerente.map((item, index) => {
                                        return (
                                            <option key={index} value={item.id}>
                                                {item.login}
                                            </option>
                                        );
                                    })}
                                </select>
                            </div>
                        )}

                        <div className='input-criacao-usuario margin-vertical-30'>
                            <label className='titulo-input-criacao'>Login:</label>
                            <input
                                required
                                onChange={(c) => setLogin(c.target.value)}
                                type='text'
                                maxLength='30'
                                className='form-control input-dados-criar'
                                value={login}
                            />
                        </div>

                        <div className='input-criacao-usuario margin-vertical-30'>
                            <label className='titulo-input-criacao'>Senha:</label>
                            <input
                                required
                                onChange={(c) => setSenha(c.target.value)}
                                type='password'
                                maxLength='30'
                                className='form-control input-dados-criar'
                                value={senha}
                            />
                        </div>

                        {nivel === 'operador' && (
                            <>
                                {/* Cambista e cliente são menus separados: o tipo é definido
                                    na criação e o backend ignora mudanças nele. */}
                                <div className='input-criacao-usuario margin-vertical-30'>
                                    <label className='titulo-input-criacao' style={{ marginBottom: 10 }}>Tipo:</label>
                                    <input
                                        disabled
                                        className='form-control input-dados-criar'
                                        value={tipoOperador(tipoGerente).nome}
                                    />
                                </div>

                                <InputUsuario
                                    name={'Saldo (R$)'}
                                    valor={saldo}
                                    func={(e) => setSaldo(moedaInput(e))}
                                    inputMode="decimal"
                                />

                                <div className='input-criacao-usuario margin-vertical-30'>
                                    <label className='titulo-input-criacao'>Cotações (R$):</label>
                                    <select
                                        required
                                        className='form-control input-dados-criar'
                                        value={cotaEscolhida}
                                        onChange={(e) => setCotaEscolhida(parseInt(e.target.value))}
                                    >
                                        {modalidades.map((m) => (
                                            <option key={m.id} value={m.id}>
                                                {m.nome.replace(/duque\s*de\s*grupo\s*combinado/gi, "Grupo Combinado")}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className='input-criacao-usuario margin-vertical-30'>
                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                        <label className='titulo-input-criacao' style={{ flex: 1 }}>Comissão (%):</label>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px', flexDirection: 'column' }}>
                                            {cotacaoSelecionada && (() => {
                                                const indicador = obterIndicadorGeral();
                                                return (
                                                    <span style={{
                                                        backgroundColor: indicador.cor,
                                                        color: '#fff',
                                                        padding: '4px 12px',
                                                        borderRadius: '12px',
                                                        fontSize: '11px',
                                                        fontWeight: 'bold'
                                                    }}>
                                                        {indicador.status}
                                                    </span>
                                                );
                                            })()}
                                        </div>
                                    </div>
                                    <div style={{
                                        flex: 1,
                                        display: 'flex',
                                        gap: '30px',
                                        alignItems: 'flex-start',
                                        width: '100%',
                                        position: 'relative',
                                        marginLeft: '28px',
                                    }}>
                                        <div style={{ flex: '0 0 auto', minWidth: '450px' }}>
                                            <div style={{
                                                display: 'flex',
                                                gap: '1px',
                                                alignItems: 'flex-start'
                                            }}>
                                                {cotacaoSelecionada && (() => {
                                                    const valores = extrairValoresCotacao(cotacaoSelecionada.nome);
                                                    const indMilhar = calcularIndicadorMilhar(valores.M, parseFloat(comissaoMilhar) || 0);
                                                    const indCentena = calcularIndicadorCentena(valores.C, parseFloat(comissaoCentena) || 0);
                                                    const indDezena = calcularIndicadorDezena(valores.D, parseFloat(comissaoDezena) || 0);
                                                    const indGrupo = calcularIndicadorGrupo(valores.G, parseFloat(comissaoGrupo) || 0);

                                                    return (
                                                        <>
                                                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                                <div style={{ display: 'flex', alignItems: 'center', gap: '1px', marginBottom: '3px' }}>
                                                                    <span style={{ fontSize: '11px', fontWeight: '500', color: '#666' }}>Milhar</span>
                                                                    <span style={{ fontSize: '15px', color: indMilhar.cor }}>{indMilhar.simbolo}</span>
                                                                </div>
                                                                <input
                                                                    type="number"
                                                                    inputMode="numeric"
                                                                    pattern="[0-9]*"
                                                                    className="form-control"
                                                                    style={{ width: '50px', textAlign: 'center', minWidth: '55px' }}
                                                                    value={comissaoMilhar}
                                                                    onChange={(e) => handleComissaoChange(e.target.value, setComissaoMilhar)}
                                                                    placeholder="30"
                                                                    maxLength="2"
                                                                />                                                    </div>
                                                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                                <div style={{ display: 'flex', alignItems: 'center', gap: '1px', marginBottom: '3px' }}>
                                                                    <span style={{ fontSize: '11px', fontWeight: '500', color: '#666' }}>Centena</span>
                                                                    <span style={{ fontSize: '15px', color: indCentena.cor }}>{indCentena.simbolo}</span>
                                                                </div>
                                                                <input
                                                                    type="number"
                                                                    inputMode="numeric"
                                                                    pattern="[0-9]*"
                                                                    className="form-control"
                                                                    style={{ width: '70px', textAlign: 'center', minWidth: '55px' }}
                                                                    value={comissaoCentena}
                                                                    onChange={(e) => handleComissaoChange(e.target.value, setComissaoCentena)}
                                                                    placeholder="30"
                                                                    maxLength="2"
                                                                />                                                    </div>
                                                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                                <div style={{ display: 'flex', alignItems: 'center', gap: '1px', marginBottom: '3px' }}>
                                                                    <span style={{ fontSize: '11px', fontWeight: '500', color: '#666' }}>Dezena</span>
                                                                    <span style={{ fontSize: '15px', color: indDezena.cor }}>{indDezena.simbolo}</span>
                                                                </div>
                                                                <input
                                                                    type="number"
                                                                    inputMode="numeric"
                                                                    pattern="[0-9]*"
                                                                    className="form-control"
                                                                    style={{ width: '70px', textAlign: 'center', minWidth: '55px' }}
                                                                    value={comissaoDezena}
                                                                    onChange={(e) => handleComissaoChange(e.target.value, setComissaoDezena)}
                                                                    placeholder="30"
                                                                    maxLength="2"
                                                                />                                                    </div>
                                                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                                <div style={{ display: 'flex', alignItems: 'center', gap: '1px', marginBottom: '3px' }}>
                                                                    <span style={{ fontSize: '11px', fontWeight: '500', color: '#666' }}>Grupo</span>
                                                                    <span style={{ fontSize: '15px', color: indGrupo.cor }}>{indGrupo.simbolo}</span>
                                                                </div>
                                                                <input
                                                                    type="number"
                                                                    inputMode="numeric"
                                                                    pattern="[0-9]*"
                                                                    className="form-control"
                                                                    style={{ width: '70px', textAlign: 'center', minWidth: '55px' }}
                                                                    value={comissaoGrupo}
                                                                    onChange={(e) => handleComissaoChange(e.target.value, setComissaoGrupo)}
                                                                    placeholder="30"
                                                                    maxLength="2"
                                                                />                                                    </div>
                                                        </>
                                                    );
                                                })()}
                                            </div>
                                        </div>

                                        <div style={{
                                            flex: '1',
                                            marginLeft: '20px',
                                            position: 'absolute',
                                            left: '49%',
                                        }}>
                                            <div style={{ fontSize: '12px', marginBottom: '10px', fontStyle: 'italic', fontWeight: 'bold' }}>
                                                Tabela de referência de comissão
                                            </div>
                                            <table style={{ width: '100%', fontSize: '11px', borderCollapse: 'collapse', border: '1px solid #dee2e6' }}>
                                                <thead>
                                                    <tr style={{ backgroundColor: '#f8f9fa' }}>
                                                        <th style={{ color: '#4169E1', textAlign: 'center', padding: '6px 4px', fontWeight: '600', borderRight: '1px solid #dee2e6', borderBottom: '1px solid #dee2e6' }}>Milhar</th>
                                                        <th style={{ color: '#4169E1', textAlign: 'center', padding: '6px 4px', fontWeight: '600', borderRight: '1px solid #dee2e6', borderBottom: '1px solid #dee2e6' }}>Centena</th>
                                                        <th style={{ color: '#4169E1', textAlign: 'center', padding: '6px 4px', fontWeight: '600', borderRight: '1px solid #dee2e6', borderBottom: '1px solid #dee2e6' }}>Dezena</th>
                                                        <th style={{ color: '#4169E1', textAlign: 'center', padding: '6px 4px', fontWeight: '600', borderBottom: '1px solid #dee2e6' }}>Grupo</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td style={{ color: '#4169E1', padding: '4px', textAlign: 'center', borderRight: '1px solid #dee2e6' }}>5.000→30%</td>
                                                        <td style={{ color: '#4169E1', padding: '4px', textAlign: 'center', borderRight: '1px solid #dee2e6' }}>500→30%</td>
                                                        <td style={{ color: '#4169E1', padding: '4px', textAlign: 'center', borderRight: '1px solid #dee2e6' }}>60→30%</td>
                                                        <td style={{ color: '#4169E1', padding: '4px', textAlign: 'center' }}>15→30%</td>
                                                    </tr>
                                                    <tr style={{ backgroundColor: '#f8f9fa' }}>
                                                        <td style={{ color: '#4169E1', padding: '4px', textAlign: 'center', borderRight: '1px solid #dee2e6' }}>6.000→30%</td>
                                                        <td style={{ color: '#4169E1', padding: '4px', textAlign: 'center', borderRight: '1px solid #dee2e6' }}>600→30%</td>
                                                        <td style={{ color: '#4169E1', padding: '4px', textAlign: 'center', borderRight: '1px solid #dee2e6' }}>70→20%</td>
                                                        <td style={{ color: '#4169E1', padding: '4px', textAlign: 'center' }}>18→15%</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ color: '#4169E1', padding: '4px', textAlign: 'center', borderRight: '1px solid #dee2e6' }}>7.000→20%</td>
                                                        <td style={{ color: '#4169E1', padding: '4px', textAlign: 'center', borderRight: '1px solid #dee2e6' }}>700→20%</td>
                                                        <td style={{ color: '#4169E1', padding: '4px', textAlign: 'center', borderRight: '1px solid #dee2e6' }}>80→10%</td>
                                                        <td style={{ color: '#4169E1', padding: '4px', textAlign: 'center' }}>20→10%</td>
                                                    </tr>
                                                </tbody>
                                            </table>

                                            <div style={{ marginTop: '15px', padding: '10px', backgroundColor: '#fff3cd', border: '1px solid #ffc107', borderRadius: '4px', fontSize: '11px' }}>
                                                <strong style={{ color: '#856404' }}>⚠️ Legendas dos indicadores:</strong>
                                                <div style={{ marginTop: '1px', lineHeight: '1.6' }}>
                                                    <div><span style={{ color: '#28a745' }}>● Verde</span> = Comissão baixa (ideal)</div>
                                                    <div><span style={{ color: '#ffc107' }}>● Amarelo</span> = Comissão média (atenção)</div>
                                                    <div><span style={{ color: '#dc3545' }}>● Vermelho</span> = Comissão alta (risco)</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </>
                        )}

                        {nivel === 'gerente' && (
                            <>
                                <div className='input-criacao-usuario margin-vertical-30'>
                                    <label
                                        className='titulo-input-criacao'
                                        style={{ marginBottom: 10 }}
                                    >
                                        Tipo:
                                    </label>
                                    <select
                                        required
                                        className='form-control input-dados-criar'
                                        id='inputTipoGerente'
                                        onChange={(e) => setTipoGerente(e.target.value)}
                                        value={tipoGerente}
                                    >
                                        <option value={'gerente'}>Gerente</option>
                                        <option value={'socio'}>Sócio</option>
                                    </select>
                                </div>

                                {tipoGerente === 'gerente' ? (
                                    <>
                                        <InputUsuario
                                            name={'Comissão Bruto (%)'}
                                            valor={comissaoGerente}
                                            func={(e) => setComissaoGerente(e.replace(/\D/g, '').slice(0, 2))}
                                            inputMode="numeric"
                                            maxLength="2"
                                        />
                                        <InputUsuario
                                            name={'Comissão Lucro (%)'}
                                            valor={comissaoLucro}
                                            func={(e) => setComissaoLucro(e.replace(/\D/g, '').slice(0, 2))}
                                            inputMode="numeric"
                                            maxLength="2"
                                        />
                                    </>
                                ) : (
                                    <InputUsuario
                                        name={'% Sócio'}
                                        valor={porcentagemSocio}
                                        func={(e) => setPorcentagemSocio(e)}
                                        tipo={'number'}
                                    />
                                )}
                            </>
                        )}

                        <InputUsuario
                            name={'Endereço'}
                            valor={endereco}
                            func={(e) => setEndereco(e)}
                        />

                        <InputUsuario
                            name={'Telefone'}
                            valor={telefone}
                            func={(e) => setTelefone(mascaraTelefone(e))}
                            tipo="tel"
                            inputMode="tel"
                        />

                        <div className='input-criacao-usuario margin-vertical-30'>
                            <label className='titulo-input-criacao'>Descrição:</label>
                            <textarea
                                className='form-control input-dados-criar'
                                onChange={(c) => setDescricao(c.target.value)}
                                rows='3'
                                value={descricao || ''}
                            />
                        </div>

                        {nivel === 'gerente' && (
                            <>
                                <div className='input-criacao-usuario margin-vertical-30'>
                                    <label className='titulo-input-criacao'>Permissões:</label>
                                    <div className='funkyradio-info'>
                                        <input
                                            type='checkbox'
                                            id='criar-operador'
                                            onChange={() =>
                                                setPermissaoCriarOperador(!permissaoCriarOperador)
                                            }
                                            checked={permissaoCriarOperador}
                                        />
                                        &nbsp;
                                        <label htmlFor='criar-operador'>Criar Cambista</label>
                                        <br />
                                        <input
                                            type='checkbox'
                                            id='adicionar-saldo'
                                            onChange={() =>
                                                setPermissaoAdicionarSaldo(!permissaoAdicionarSaldo)
                                            }
                                            checked={permissaoAdicionarSaldo}
                                        />
                                        &nbsp;
                                        <label htmlFor='adicionar-saldo'>Adicionar saldo</label>
                                    </div>
                                </div>

                                <div className='input-criacao-usuario margin-vertical-30'>
                                    <label className='titulo-input-criacao'>Apagar Gerente:</label>
                                    <button
                                        className='btn btn-danger btn-small'
                                        onClick={() => {
                                            perguntarParaApagar();
                                        }}
                                    >
                                        Apagar
                                    </button>
                                </div>
                            </>
                        )}
                    </div>

                    {nivel === "operador" && (
                        <div className="input-criacao-usuario margin-vertical-30">
                            <label className="titulo-input-criacao">
                                Permissões:
                            </label>
                            <div className="funkyradio-info">
                                <input
                                    type="checkbox"
                                    id="exibir-logo"
                                    onChange={() =>
                                        setPermissaoExibirLogo(
                                            !permissaoExibirLogo
                                        )
                                    }
                                    checked={permissaoExibirLogo}
                                />
                                &nbsp;
                                <label htmlFor="exibir-logo">
                                    Exibir logo
                                </label>
                                <br />
                                <input
                                    type="checkbox"
                                    id="milhar-brinde"
                                    onChange={() =>
                                        setMilharBrindeUsuario(!milharBrindeUsuario)
                                    }
                                    checked={milharBrindeUsuario}
                                />
                                &nbsp;
                                <label htmlFor="milhar-brinde">
                                    Milhar brinde
                                </label>
                            </div>
                        </div>
                    )}

                    {nivel === 'operador' && (
                        <div style={{ padding: 10 }}>
                            <p style={{ color: '#cc0000' }}>
                                <strong>Milhar:</strong> para milhar e suas subcategorias.
                            </p>
                            <p style={{ color: '#cc0000' }}>
                                <strong>Centena:</strong> para centena e suas subcategorias.
                            </p>
                            <p style={{ color: '#cc0000' }}>
                                <strong>Dezena:</strong> para dezena e suas subcategorias.
                            </p>
                            <p style={{ color: '#cc0000' }}>
                                <strong>Grupo:</strong> para grupo e suas subcategorias.
                            </p>
                            <p style={{ color: '#cc0000' }}>
                                Na opção cliente a comissão ganha em cada bilhete volta em forma de saldo.
                            </p>
                        </div>
                    )}

                    {nivel === 'subadmin' && (
                        <SecaoPermissoes
                            usuarioId={props.match.params.id}
                            filtrarPor={PERMISSOES_SUBADMIN}
                            permiteRestaurarPadrao={false}
                        />
                    )}

                    <div
                        style={{
                            padding: '0 10px',
                            justifyContent: 'left',
                        }}
                        className='d-flex m-b m-t'
                    >
                        <button
                            style={{ display: 'block', width: '270px', marginLeft: '150px' }}
                            className='btn btn-success'
                            onClick={() => enviarModificacao()}
                        >
                            Salvar
                        </button>
                    </div>
                </>)}
            </div>
        </div>
    );
}